import React, { Component } from "react";
import ReactDOM from 'react-dom';
import commonUtil from "../../../utils/commonUtil";
import _ from "lodash";
import { browserHistory } from "react-router";
import pdfUtil from "../../../utils/PDFUtil";
import StatementPrintAndDownload from "../../BrowseAndNavigate/AccountSummary/components/StatementPrintAndDownload";
import Link from "../../../components/ZUILib/Link";
import Image from "../../../components/ZUILib/Image";
import { sendMail } from "../../BrowseAndNavigate/AccountSummary/actions";
import SelectionTab from "../../../components/ZUILib/SelectionTab";
import MultiSelectDropdown from "../../../components/MultiSelectDropdown";
import Pagination from "../../../components/Pagination";
import DownloadPDFWithoutPreview from "../../../components/DownloadPDFWithoutPreview";
import {
  constDownload,
  constPrint,
  constSendMail,
  UIBrands,
} from "../../../utils/clientConstant";
import GiftListTableFiltersModalWap from "./GiftListTableFiltersModalWap";
import NoGiftItemsMessageWap from "./subComponents/NoGiftItemsMessageWap";

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = "accountstatus";

class GiftSummaryTableWap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: {},
      selectedStore: {},
      selectedBonus: {},
      emailSendStatus: null,
      filterModal: false,
      filteredProductsCount: 0
    };

    this.eventId = this.props.eventId;
    this.eventInfo = this.props.eventInfo;
    this.isViewAll = false;
    this.currentPage = 1;
  }

  componentDidMount() {}

  onFilterModalOpen = () => {
    this.setState({
      filterModal: true,
    });
  };

  onFilterModalClose = () => {
    this.setState({
      filterModal: false,
    });
    const scrollY = document.body.style.top;

    document.body.classList.remove('body-no-scroll-fixed');
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };

  handleOptionChange = (selectedData, event) => {
    this.setState({ selectedOption: selectedData });
    this.updateFilterParams("date", selectedData.value,false,false,true);
  };

  handleStoreChange = (selectedData, event) => {
    this.setState({ selectedStore: selectedData });
    this.updateFilterParams("store", selectedData.value,false,false,true);
  };

  handleBonusChange = (selectedData, event) => {
    this.setState({ selectedBonus: selectedData });
    this.updateFilterParams("bonusApplicable", selectedData.value,false,false,true);
  };

  setFilteredProductsCount = (count) => {
    this.setState({filteredProductsCount: count});
  }

  getStatementDetailsForDownload = (isBonusContainerVisible) => {
    this.printDownloadMail(constDownload,isBonusContainerVisible);
  };
  getStatementDetailsForPrint = () => {
    this.printDownloadMail(constPrint);
  };
  getStatementDetailsForSendMail = (isBonusContainerVisible) => {
    this.printDownloadMail(constSendMail,isBonusContainerVisible);
  };
  accountStatementSendMail = (fileName, data) => {
    const emailId =
      !commonUtil.isObjectEmpty(this.props.user) &&
      this.props.user.result &&
      this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status && res.body.status.status && res.body.status.status === 'success') {
        this.props.showMessagePopUp(true,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailsent.message',
        ));
      } else {
        this.props.showMessagePopUp(false,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailfailed.message',
        ));
      }
    }).catch((e) => {
      pdfUtil.contentDownloadedCallback();
      this.props.showMessagePopUp(false,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailfailed.message',
        ));
    });
  };

  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }

  contentDownloadedCallback = () => {
    ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(document.querySelector('#downloadContainer')));
    commonUtil.hideApplicationLoader();

    const channel = commonUtil.getChannel();

    this.props.showMessagePopUp(true,commonUtil.getLabel(
      this.props.lables.eventAccountStatement,
      'accountStatement.download.success.message',
    ),channel === 'web');
  }

  printDownloadMail = (type,isBonusContainerVisible) => {
    if (type === constSendMail) {
      // const mailContent = (
      //   <DownloadPDFWithoutPreview
      //     pageName={pageName}
      //     printingDate={this.props.printingDate}
      //     download
      //   >
      //     <StatementPrintAndDownload
      //       statementPrintAndDownload={
      //         this.props.statementDetailsForPrintAndDownloadData
      //       }
      //       eventDetailsInfo={this.props.eventInfo}
      //       type={this.downloadPrintType}
      //       accountStatus={this.props.accountStatus}
      //       isBonusContainerVisibleGL={isBonusContainerVisible}
      //     />
      //   </DownloadPDFWithoutPreview>
      // );
      // pdfUtil.attachToDomForMail(
      //   mailContent,
      //   "accountStatement",
      //   this.accountStatementSendMail
      // );
      this.accountStatementSendMail();
    } else if (type === constDownload) {
      const downloadableContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
          download
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
            isBonusContainerVisibleGL={isBonusContainerVisible}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDom(downloadableContent, "accountstatus_" + this.eventId, this.contentDownloadedCallback);
    } else if (type === constPrint) {
      const printContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDomForPrint(printContent, pageName);
    }
  };

  onFilterSortingChange = (e) => {
    /*eslint-disable*/
    const filteringParameters = this.props.filteringParameters;
    let fpType = "",
      isRemove = false;
    if (e.senderId === "showEveryThingDropdown") {
      fpType = "date";
      if (e.value === "showAll") {
        isRemove = true;
      }
    } else if (e.senderId === "applyForBonusDropdown") {
      fpType = "bonusApplicable";
      if (e.value === "allBonus") {
        isRemove = true;
      }
    }
    this.updateFilterParams(fpType, e.value, isRemove);
    /*eslint-enable*/
  };

  onBrandChange = (e) => {
    let isRemove = false;
    let value = "";
    if (e.length > 0) {
      for (let i = 0; i < e.length; i++) {
        if (!e[i].isAllSelector) {
          value += e[i].value + ",";
        }
      }
      value = value.substr(0, value.length - 1);
    } else {
      isRemove = true;
    }
    if (e.length && e[0].isAllSelector && e[0].isChecked) {
      isRemove = true;
    }
    this.updateFilterParams("store", value, isRemove);
  };

  updateFilterParams(fpType, value, isRemove, isRemoveAll, filtersForCount) {
    let filteringParametersValue = [];
    if(filtersForCount){
      filteringParametersValue = this.props.filteringParametersForCount;
    }else{
      filteringParametersValue = this.props.filteringParameters;
    }

    if (isRemoveAll) {
      filteringParametersValue.splice(0, filteringParametersValue.length);
    } else if (isRemove) {
      for (let i = 0; i < filteringParametersValue.length; i++) {
        if (filteringParametersValue[i].type === fpType) {
          filteringParametersValue.splice(i, 1);
        }
      }
      if(filtersForCount){
        const count = this.filterProductsCount(this.props?.initialPurchasedItemsDetailsData?.itemsInfo || [], filteringParametersValue);
        this.setFilteredProductsCount(count);
      }
      this.props.handleFilterParametersChange(filteringParametersValue, filtersForCount);
    } else {
      const type = _.find(filteringParametersValue, { type: fpType });
      if (type) {
        type.value = value;
      } else {
        filteringParametersValue.push({ type: fpType, value });
      }

      if(filtersForCount){
        const count = this.filterProductsCount(this.props?.initialPurchasedItemsDetailsData?.itemsInfo || [], filteringParametersValue);
        this.setFilteredProductsCount(count);
      }
      this.props.handleFilterParametersChange(filteringParametersValue, filtersForCount);
    }

    if(isRemoveAll){
      this.props.getFilterSorted(
        filteringParametersValue,
        this.props.sortingParameters,
        this.currentPage,
        this.isViewAll,
        isRemoveAll
      );
    }
  }

  onViewItemsClick = () => {
    const {selectedOption,selectedStore,selectedBonus} = this.state;

    if(selectedOption.value){
      this.updateFilterParams("date", selectedOption.value);
    }else{
      this.updateFilterParams("date", '', true);
    }

    if(selectedStore.value){
      this.updateFilterParams("store", selectedStore.value);
    }else{
      this.updateFilterParams("store", '', true);
    }

    if(selectedBonus.value){
      this.updateFilterParams("bonusApplicable", selectedBonus.value);
    }else{
      this.updateFilterParams("bonusApplicable", '', true);
    }

    let filterParameterValue = this.props.filteringParameters;

    this.props.getFilterSorted(
      filterParameterValue,
      this.props.sortingParameters,
      this.currentPage,
      this.isViewAll
    );

    this.onFilterModalClose();
  }

  onViewAllClick = () => {
    this.isViewAll = true;
    this.props.getFilterSorted(
      this.props.filteringParameters,
      this.props.sortingParameters,
      this.currentPage,
      true
    );
  };

  onPageChange = (value) => {
    this.currentPage = value;
    this.props.getFilterSorted(
      this.props.filteringParameters,
      this.props.sortingParameters,
      this.currentPage,
      false
    );
  };

  onSortChange = (type, value) => {
    /*eslint-disable*/
    const sortingParameters = this.props.sortingParameters;
    const compareVal =
      value === "ascending"
        ? "descending"
        : value === "increasing"
        ? "decreasing"
        : value === "yes"
        ? "no"
        : "ascending";
    // Patch for allow only one sort
    const patchSort = [];
    if (sortingParameters.length && sortingParameters[0].type === type) {
      if (sortingParameters[0].value === value) {
        patchSort.push({ type: type, value: compareVal });
      } else {
        patchSort.push({ type: type, value: value });
      }
    } else {
      patchSort.push({ type: type, value: compareVal });
    }
    // this.setState({ sortingParameters: patchSort });
    this.props.getFilterSorted(
      this.props.filteringParameters,
      patchSort,
      this.currentPage,
      this.isViewAll
    );
    /*eslint-enable*/
  };
  rediectToPage = () => {
    browserHistory.push(
      commonUtil.routeTo(applicationRoutes.accountStatus, {
        eventID: this.props.eventId,
      })
    );
  };

  splitPrice = (value) => {
    const str = String(value).trim();

    const match = str.match(/^(\D?)([\d,]+)(?:\.(\d+))?$/);
    if (!match) {
      return {
        currency: '$',
        integerWithDot: '0.',
        decimal: '00'
      };
    };
  
    const currency = match[1] || '';
    const rawIntegerPart = match[2].replace(/,/g, '');
    const decimalPart = match[3] || '00';
  
    const formattedInt = Number(rawIntegerPart).toLocaleString();
  
    return {
      currency,
      integerWithDot: formattedInt + '.',
      decimal: decimalPart.padEnd(2, '0')
    };
  };

  onClearFilters = (removeAll, removeSelectedValue, fpType) => {
    const { selectedOption, selectedStore, selectedBonus } = this.state;

    if (removeAll) {
      this.setState({
        selectedOption: {},
        selectedStore: {},
        selectedBonus: {},
      });

      this.updateFilterParams(fpType, removeSelectedValue, false, true);
      this.onFilterModalClose();
    } else if (removeSelectedValue) {
      this.setState({
        selectedOption:
          removeSelectedValue == selectedOption.value ? {} : selectedOption,
        selectedStore:
          removeSelectedValue == selectedStore.value ? {} : selectedStore,
        selectedBonus:
          removeSelectedValue == selectedBonus.value ? {} : selectedBonus,
      });

      this.updateFilterParams(fpType, removeSelectedValue, true, false, true);
    }
  };

  onCloseModal = () => {
    const {
      filteringParameters,
    } = this.props;

    if (filteringParameters && filteringParameters.length == 0) {
      this.setState({
       selectedOption: {},
       selectedStore: {},
       selectedBonus: {},
      });

      this.props.handleFilterParametersChange([], true);
    } else {
      if(!this.props.filteringParameters.some(item => item.type === 'date')){
        this.setState({
          selectedOption: {}
        });

        this.updateFilterParams("date", "", true, false, true);
      }

      if(!this.props.filteringParameters.some(item => item.type === 'store')){
        this.setState({
          selectedStore: {}
        });

        this.updateFilterParams("store", "", true, false, true);
      }

      if(!this.props.filteringParameters.some(item => item.type === 'bonusApplicable')){
        this.setState({
          selectedBonus: {}
        });

        this.updateFilterParams("bonusApplicable", "", true, false, true);
      }
    }

    this.onFilterModalClose();
  }

  normalizeDate = (d) => {
    const nd = new Date(d);
    nd.setHours(0, 0, 0, 0);
    return nd;
  };

  filterProductsCount = (itemsInfo, filters) => {
    const today = new Date();
  
    // No filters → return all items count
    if (!filters || filters.length === 0) {
      return itemsInfo.length;
    }
  
    return itemsInfo.filter(item => {
      let isValid = true;
  
      filters.forEach(filter => {
        const { type, value } = filter;
  
        switch (type) {
          case "store":
            if (item.brand !== value) isValid = false;
            break;
  
          case "bonusApplicable":
            if (item.bonusInfo !== value) isValid = false;
            break;
  
          case "date":
            if (value) {
              const [day, month, year] = item.purchasedDate.split("/").map(Number);
              const itemDate = this.normalizeDate(new Date(year, month - 1, day));
  
              const cutoff = this.normalizeDate(new Date(today));
              cutoff.setMonth(cutoff.getMonth() - parseInt(value, 10));
  
              if (itemDate < cutoff) isValid = false;
            }
            break;
  
          default:
            break;
        }
      });
  
      return isValid;
    }).length;
  }

  render() {
    const { selectedOption, selectedStore, selectedBonus, filterModal } =
      this.state;

    const {
      isPhysical,
      isElectronic,
      isPersonal,
      selectedTheme,
      filteringParameters,
      isBonusContainerVisible,
    } = this.props;

    const giftListCategoryLabel = isPhysical
      ? commonUtil.getLabel(
          this.props.lables['Physical Gifts Details Page'],
          'accountStatement.physical.label1'
        )
      : isElectronic
      ? commonUtil.getLabel(
          this.props.lables['Electronic Gifts Details Page'],
          'accountStatement.electronic.label2'
        )
      : isPersonal
      ? commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.personal.category.header.text',
        )
      : "";

    const giftListCategorySubText = isPhysical
      ? commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.gift.table.physical.summary.text',
        )
      : isElectronic
      ? commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.gift.table.electronic.summary.text',
        )
      : isPersonal
      ? commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.gift.table.personal.summary.text',
        )
      : "";

    const giftlistSummaryGiftText = isPhysical
      ? commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.gift.table.pilling.up.text',
        )
      : isElectronic
      ? commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.gift.table.pilling.up.text',
        )
      : isPersonal
      ? commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.gift.table.pilling.up.compras.text',
        )
      : "";

    const CantidadText = isPhysical
      ? commonUtil.getLabel(
        this.props.lables.eventAccountStatement,
        'accountStatement.physical.quantity.text',
      )
      : isElectronic
      ? commonUtil.getLabel(
        this.props.lables.eventAccountStatement,
        'accountStatement.electronic.quantity.text',
      )
      : isPersonal
      ? commonUtil.getLabel(
        this.props.lables.eventAccountStatement,
        'accountStatement.personal.product.quantity.text',
      )
      : "";

    const sumTotalText = isPhysical
      ? commonUtil.getLabel(
        this.props.lables.eventAccountStatement,
        'accountStatement.physical.sum.total.text',
      )
      : isElectronic
      ? commonUtil.getLabel(
        this.props.lables.eventAccountStatement,
        'accountStatement.electronic.sum.total.text',
      )
      : isPersonal
      ? commonUtil.getLabel(
        this.props.lables.eventAccountStatement,
        'accountStatement.personal.sum.total.text',
      )
      : "";

    const purchasedItemSummaryInfoData =
      this.props.purchasedItemSummaryInfoData;

    const bonusPercentage =
      this.props?.statementDetailsForPrintAndDownloadData?.accountStatementInfo
        ?.bonusDetails?.bonusPercentage || 0;

    // const paginationInfo = this.props.purchasedItemsDetailsData && this.props.purchasedItemsDetailsData.paginationInfo ? this.props.purchasedItemsDetailsData.paginationInfo : null;

    const DownloadIcon = {
      route: "",
    };
    const RegresarLink = {
      text: "Regresar",
      children: "Regresar",
      cssClass: "lightLink size-Medium",
      onClickHandler: this.rediectToPage,
    };
    const viewAll = {
      text: "Ver todo",
      href: "javascript:void(0);",
      onClickHandler: this.onViewAllClick,
    };
    const emailSendLink = {
      cssClass: "icon-tache2 closeAlert",
      onClickHandler: () => {
        this.setState({ emailSendStatus: null });
      },
    };

    const sortUpIcon = (
      <i
        className="iClass icon-flecha_filtros_arriba filter-arrow"
        aria-hidden="true"
      />
    );
    const sortDownIcon = (
      <i
        className="iClass icon-flecha_filtros_abajo filter-arrow"
        aria-hidden="true"
      />
    );

    let totalPurchasedAmount = purchasedItemSummaryInfoData?.itemSummary
      ?.totalPurchasedAmount
      ? commonUtil.getCurrency(
          purchasedItemSummaryInfoData?.itemSummary?.totalPurchasedAmount
        )
      : "$0";
    totalPurchasedAmount = this.splitPrice(totalPurchasedAmount);

    let totalAmountEligibleForBonus = purchasedItemSummaryInfoData?.itemSummary
      ?.totalAmountEligibleForBonus
      ? commonUtil.getCurrency(
          purchasedItemSummaryInfoData?.itemSummary?.totalAmountEligibleForBonus
        )
      : "$0";
    totalAmountEligibleForBonus = this.splitPrice(totalAmountEligibleForBonus);

    let totalBonusAmount = purchasedItemSummaryInfoData?.itemSummary
      ?.totalBonusAmount
      ? commonUtil.getCurrency(
          purchasedItemSummaryInfoData?.itemSummary?.totalBonusAmount
        )
      : "$0";
    totalBonusAmount = this.splitPrice(totalBonusAmount);

    let totalAmountNotEligibleForBonus = purchasedItemSummaryInfoData
      ?.itemSummary?.totalAmountNotEligibleForBonus
      ? commonUtil.getCurrency(
          purchasedItemSummaryInfoData?.itemSummary
            ?.totalAmountNotEligibleForBonus
        )
      : "$0";
    totalAmountNotEligibleForBonus = this.splitPrice(
      totalAmountNotEligibleForBonus
    );

    const productImage = (data, index) => {
      const intransitImg = [
        {
          media: "(max-width: 465px)",
          srcSet: data.imageURL,
        },
      ];

      const isGiftCertificate = data.categoryName === "Gift Certificate" || data.categoryName === "Certificado Electrónico";

      const intransitImage = {
        src: data.imageURL,
        altImg: commonUtil.getAssetURL() + "/images/guest/no-image.png",
        width: 78,
        height: isGiftCertificate ? 55 : 129,
        className: `img-responsive ${isGiftCertificate ? "giftlist-summary-gifttable-image-cert-img" : "giftlist-summary-gifttable-image-img"}`,
      };

      return <Image imageAttr={intransitImage} _imgsrc={intransitImg} />;
    };

    const themeColor500 = selectedTheme?.color_500;
    const themeColor50 = selectedTheme?.color_50;
    const themeColor700 = selectedTheme?.color_700;
    const themeColor100 = selectedTheme?.color_100;

    return (
      <div className="gift-list-table-summary-container-wap">
        <div className="giftlist-gifttype-box-wap">
          <span className="giftlist-gifttype-wap giftlist-gifttype-text-wap">
            {giftListCategoryLabel}
          </span>
        </div>
        <div className="giftlist-gifttype-textmessage-wap">
          <span>{giftListCategorySubText}</span>
        </div>
        {filterModal && (
          <GiftListTableFiltersModalWap
            ref={(giftListTableFiltersModalWAP) =>
              (this.giftListTableFiltersModalWAP = giftListTableFiltersModalWAP)
            }
            title={"Filtrar y ordenar"}
            hideModalOverlay={this.onFilterModalClose}
            selectedOption={selectedOption}
            selectedStore={selectedStore}
            selectedBonus={selectedBonus}
            handleOptionChange={this.handleOptionChange}
            handleStoreChange={this.handleStoreChange}
            handleBonusChange={this.handleBonusChange}
            onClearFilters={this.onClearFilters}
            onViewItemsClick={this.onViewItemsClick}
            filterProductsCount={this.filterProductsCount}
            setFilteredProductsCount={this.setFilteredProductsCount}
            filteredProductsCount={this.state.filteredProductsCount}
            filteringParametersForCount={this.props.filteringParametersForCount}
            isPhysical={isPhysical}
            isElectronic={isElectronic}
            isPersonal={isPersonal}
            channel={this.props.channel}
            purchasedItemSummaryInfoData={
              this.props.purchasedItemSummaryInfoData
            }
            purchasedItemsDetailsData={this.props.purchasedItemsDetailsData}
            initialPurchasedItemsDetailsData={this.props.initialPurchasedItemsDetailsData}
            getFilterSorted={this.props.getFilterSorted}
            accountStatus={this.props.accountStatus}
            lables={this.props.lables}
            eventId={this.props.eventId}
            user={this.props.user}
            eventInfo={this.props.eventInfo}
            statementDetailsForPrintAndDownloadData={
              this.props.statementDetailsForPrintAndDownloadData
            }
            printingDate={this.props.printingDate}
            selectedTheme={this.props.selectedTheme}
            sortingParameters={this.props.sortingParameters}
            filteringParameters={this.props.filteringParameters}
            isBonusContainerVisible={this.props.isBonusContainerVisible}
            onCloseModal={this.onCloseModal}
          />
        )}
        <div
          style={{ "--color-50": themeColor50 }}
          className="giftlist-gifttype-status-box-wap"
        >
          <div className="giftlist-gifttype-status-wap">
            {isPhysical ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 6.19L17 10.69V18.5H15V12.5H9V18.5H7V10.69L12 6.19ZM12 3.5L2 12.5H5V20.5H11V14.5H13V20.5H19V12.5H22L12 3.5Z"
                  fill={themeColor500}
                />
              </svg>
            ) : isElectronic ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.31 11.14C10.54 10.69 9.97 10.2 9.97 9.47C9.97 8.63 10.76 8.04 12.07 8.04C13.45 8.04 13.97 8.7 14.01 9.68H15.72C15.67 8.34 14.85 7.11 13.23 6.71V5H10.9V6.69C9.39 7.01 8.18 7.99 8.18 9.5C8.18 11.29 9.67 12.19 11.84 12.71C13.79 13.17 14.18 13.86 14.18 14.58C14.18 15.11 13.79 15.97 12.08 15.97C10.48 15.97 9.85 15.25 9.76 14.33H8.04C8.14 16.03 9.4 16.99 10.9 17.3V19H13.24V17.33C14.76 17.04 15.96 16.17 15.97 14.56C15.96 12.36 14.07 11.6 12.31 11.14Z"
                  fill={themeColor500}
                />
              </svg>
            ) : isPersonal ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M22 10.8701L19.26 9.28009C19.5 9.07009 19.73 8.80009 19.9 8.50009C20.73 7.07009 20.24 5.23009 18.8 4.40009C17.94 3.90009 16.93 3.90009 16.08 4.26009L16.09 4.25009L15.21 4.64009L15.1 3.68009L15.09 3.69009C15 2.78009 14.47 1.90009 13.61 1.40009C12.17 0.575086 10.34 1.07009 9.5 2.50009C9.33 2.80009 9.22 3.13009 9.16 3.45009L6.41 1.87009C5.45 1.32009 4.23 1.64009 3.68 2.60009L2.18 5.20009C1.9 5.68009 2.07 6.29009 2.55 6.56009L4.28 7.56009L8.5 10.0001H2V20.0001C2 21.1101 2.9 22.0001 4 22.0001H20C21.11 22.0001 22 21.1101 22 20.0001V14.8701L22.73 13.6001C23.28 12.6401 22.96 11.4201 22 10.8701ZM16.44 6.50009C16.71 6.00009 17.33 5.86009 17.8 6.13009C18.28 6.41009 18.45 7.00009 18.17 7.50009C17.89 8.00009 17.28 8.14009 16.8 7.87009C16.33 7.59009 16.16 7.00009 16.44 6.50009ZM14.07 8.60009L21 12.6001L20 14.3301L13.07 10.3301L14.07 8.60009ZM11 20.0001H4V12.0001H11V20.0001ZM11.34 9.33009L4.41 5.33009L5.41 3.60009L12.34 7.60009L11.34 9.33009ZM11.61 4.87009C11.13 4.59009 10.97 4.00009 11.24 3.50009C11.5 3.00009 12.13 2.86009 12.61 3.13009C13.09 3.41009 13.25 4.00009 12.97 4.50009C12.7 5.00009 12.09 5.14009 11.61 4.87009ZM13 20.0001V12.6001L20 16.6401V20.0001H13Z"
                  fill={themeColor500}
                />
              </svg>
            ) : (
              ""
            )}
            <span className="giftlist-gifttype-status-text-wap">
              {giftlistSummaryGiftText}
            </span>
          </div>
        </div>
        <div className="giftlist-summary-table-container-wap">
          <div className="giftlist-accountstatement-box-wap">
            <div className="giftlist-accountstatement-box-text ">
              <span className="giftlist-accountstatement-text">
                {commonUtil.getLabel(
                  this.props.lables.eventAccountStatement,
                  'accountStatement.gift.table.download.statement.text',
                )}
              </span>
            </div>
            <div className="giftlist-accountstatement-icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                className="cursor-pointer"
                onClick={() => this.getStatementDetailsForDownload(isBonusContainerVisible)}
              >
                <circle cx="16" cy="16" r="16" fill={themeColor50} />
                <path
                  d="M22 19V21H10V19H8V21C8 22.1 8.9 23 10 23H22C23.1 23 24 22.1 24 21V19H22ZM21.1 13.5L20 12.4L17 15.4V6H15V15.4L12 12.4L10.9 13.5L16 18.6L21.1 13.5Z"
                  fill="#767676"
                />
              </svg>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                className="cursor-pointer"
                onClick={() => this.getStatementDetailsForSendMail(isBonusContainerVisible)}
              >
                <circle cx="16" cy="16" r="16" fill={themeColor50} />
                <g transform="translate(5 4.5)">
                  <path
                    d="M20.1673 5.88265C20.1673 4.87432 19.3423 4.04932 18.334 4.04932H3.66732C2.65898 4.04932 1.83398 4.87432 1.83398 5.88265V16.8826C1.83398 17.891 2.65898 18.716 3.66732 18.716H18.334C19.3423 18.716 20.1673 17.891 20.1673 16.8826V5.88265ZM18.334 5.88265L11.0007 10.466L3.66732 5.88265H18.334ZM18.334 16.8826H3.66732V7.71598L11.0007 12.2993L18.334 7.71598V16.8826Z"
                    fill="#767676"
                  />
                </g>
              </svg>
            </div>
          </div>
          <div className="giftlist-summary-container-wap">
            <div className="giftlist-summary-breakdown-wap">
              <span className="giftlist-summary-breakdown-text-wap">
                {commonUtil.getLabel(
                  this.props.lables.eventAccountStatement,
                  'accountStatement.gift.table.breakdown.text',
                )}
              </span>
            </div>
            <div className="giftlist-summary-cantidad-wap">
              <span className="giftlist-summary-cantidad-text-wap">
                {CantidadText}{" "}
              </span>
              <div className="giftlist-summary-cantidadcount-wap">
                <span className="giftlist-summary-cantidad-count-wap">
                  {purchasedItemSummaryInfoData?.itemSummary
                    ?.totalPurchasedItemsCount || "0"}
                </span>
              </div>
            </div>
            <div
              className={`giftlist-summary-totalgiftsbox-wap ${
                !isBonusContainerVisible && "border-btm-none"
              }`}
            >
              <span className="giftlist-summary-cantidad-text-wap">
                {sumTotalText}{" "}
              </span>
              <div className="giftlist-summary-totalgiftsamount-wap">
                <span className="giftlist-summary-cantidad-count-wap">
                  {totalPurchasedAmount.currency}{" "}
                  {totalPurchasedAmount.integerWithDot}{" "}
                </span>
                <span className="giftlist-summary-totalgifts-amount-wap">
                  {totalPurchasedAmount.decimal}
                </span>
              </div>
            </div>
            {isBonusContainerVisible && (
              <>
                <div className="giftlist-summary-generates-bonus-wap">
                  <span className="giftlist-summary-cantidad-text-wap">
                    {commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.gift.table.eligible.bonus.text',
                    )}{" "}
                  </span>
                  <div className="giftlist-summary-totalgiftsamount-wap">
                    <span className="giftlist-summary-cantidad-count-wap">
                      {totalAmountEligibleForBonus.currency}{" "}
                      {totalAmountEligibleForBonus.integerWithDot}{" "}
                    </span>
                    <span className="giftlist-summary-totalgifts-amount-wap">
                      {totalAmountEligibleForBonus.decimal}
                    </span>
                  </div>
                </div>
                <div className={`giftlist-summary-totalgiftsbox-wap giftlist-summary-totalgiftsbox-wap-light-border ${isElectronic && "border-btm-none"}`}>
                  <span className="giftlist-summary-cantidad-text-wap">
                    {bonusPercentage} {commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.gift.table.accumulated.bonus.text',
                    )}{" "}
                  </span>
                  <div className="giftlist-summary-totalgiftsamount-wap">
                    <span className="giftlist-summary-bonus-applicable-wap">
                      {totalBonusAmount.currency}{" "}
                      {totalBonusAmount.integerWithDot}{" "}
                    </span>
                    <span className="giftlist-summary-bonus-applicable-amount-wap">
                      {totalBonusAmount.decimal}
                    </span>
                  </div>
                </div>
                {!isElectronic && 
                <div className="giftlist-summary-generates-bonus-wap">
                  <span className="giftlist-summary-cantidad-text-wap">
                    {commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.gift.table.not.eligible.bonus.text',
                    )}{" "}
                  </span>
                  <div className="giftlist-summary-totalgiftsamount-wap">
                    <span className="giftlist-summary-cantidad-count-wap">
                      {totalAmountNotEligibleForBonus.currency}{" "}
                      {totalAmountNotEligibleForBonus.integerWithDot}{" "}
                    </span>
                    <span className="giftlist-summary-totalgifts-amount-wap">
                      {totalAmountNotEligibleForBonus.decimal}
                    </span>
                  </div>
                </div>}
              </>
            )}
          </div>
          <div className="giftlist-gifttable-container">
            <div
              style={{ "--color-100": themeColor100 }}
              className="giftlist-summary-header-box-wap"
            >
              <div className="giftlist-gifttable-header-wap">
                <span className="giftlist-gifttable-resumen-wap">{commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.gift.table.resumen.text',
                    )}</span>
                 {purchasedItemSummaryInfoData?.itemSummary
                  ?.totalPurchasedItemsCount &&
                  (purchasedItemSummaryInfoData?.itemSummary
                    ?.totalPurchasedItemsCount > 0) ? (
                    <div
                      className="giftlist-gifttable-filtersbutton-wap"
                      onClick={this.onFilterModalOpen}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M2.66699 10.963V12.1482H6.22255V10.963H2.66699ZM2.66699 3.85193V5.03712H8.59292V3.85193H2.66699ZM8.59292 13.3334V12.1482H13.3337V10.963H8.59292V9.77786H7.40773V13.3334H8.59292ZM5.03736 6.2223V7.40749H2.66699V8.59267H5.03736V9.77786H6.22255V6.2223H5.03736ZM13.3337 8.59267V7.40749H7.40773V8.59267H13.3337ZM9.7781 6.2223H10.9633V5.03712H13.3337V3.85193H10.9633V2.66675H9.7781V6.2223Z"
                          fill="#333333"
                        />
                      </svg>
                      <span className="giftlist-gifttable-filterstext-wap">
                        {commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.gift.table.filter.text',
                        )}
                      </span>
                      {filteringParameters &&
                        filteringParameters.length > 0 && (
                          <div
                            style={{ "--color-500": themeColor500 }}
                            className="giftlist-filter-counter-badge-wap"
                          >
                            <div className="giftlist-filter-counter-text-wap">
                              {filteringParameters.length}
                            </div>
                          </div>
                        )}
                    </div>
                  ) : null}
              </div>
            </div>


            {purchasedItemSummaryInfoData?.itemSummary
              ?.totalPurchasedItemsCount &&
              (purchasedItemSummaryInfoData?.itemSummary
                ?.totalPurchasedItemsCount > 0) ? (
                <div className='giftlist-summary-product-count-box-wap'>
                  <div className='giftlist-summary-product-count-left-wap'>
                    <div></div>
                    <div></div>
                  </div>
                  <div className='giftlist-summary-product-count-text-wap'>
                    <span className='giftlist-summary-product-count-bold-wap'>
                      {this.props?.purchasedItemsDetailsData?.itemsCount || '0'}{' '}
                      de{' '}
                      {this.props?.purchasedItemsDetailsData?.itemsCount || '0'}{' '}
                    </span>
                    <span className='giftlist-summary-product-count-normal-wap'>
                      {commonUtil.getLabel(
                        this.props.lables.eventAccountStatement,
                        'accountStatement.gift.table.product.text',
                      )}
                    </span>
                  </div>
                </div>
              ) : null}


            {!_.isEmpty(this.props.purchasedItemsDetailsData) &&
            !_.isEmpty(this.props.purchasedItemsDetailsData.itemsInfo) &&
            this.props.purchasedItemsDetailsData?.itemsInfo?.length > 0 ? (
              this.props.purchasedItemsDetailsData.itemsInfo.map(
                (product, index) => (
                  <>
                    <div className="giftlist-sumary-gifttable-box-wap">
                      <div className="giftlist-summary-gifttable-image">
                        {productImage(product)}
                      </div>
                      <div className="giftlist-gifttable-item-wap">
                        <div className="giftlist-sumary-gifttable-details-box-wap">
                          <div className="giftlist-gifttable-name-wap-box">
                            <span className="giftlist-gifttable-name-wap">
                              {product.displayName}
                            </span>
                          </div>
                          <div className="giftlist-gifttable-sku-box-wap">
                            <span className="giftlist-gifttable-sku-wap giftlist-gifttable-sku-wap-text-1">
                              {commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.sku.label')}: {product.skuId}
                            </span>
                          </div>
                          <div className="giftlist-gifttable-sku-box-wap">
                            <span className="giftlist-gifttable-sku-wap giftlist-gifttable-sku-wap-text-2">
                              {commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')}: {product.quantity}
                            </span>
                          </div>
                          <div className="giftlist-gifttable-sku-box-wap">
                            <span className="giftlist-gifttable-sku-box-wap giftlist-gifttable-sku-wap giftlist-gifttable-sku-wap-text-2">
                            {commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.price.label')}: $ {(() => {
                              let [integerPart, decimalPart] = (product.price || "0.00").toString().split(".");
                              return (
                                <>
                                  {integerPart}.
                                  <span className="giftlist-gifttable-sku-wap-text-2-decimal">{decimalPart || "00"}</span>
                                </>
                              );
                            })()}
                            </span>
                          </div>
                          <div className="giftlist-gifttable-sku-box-wap">
                            <span className="giftlist-gifttable-sku-wap giftlist-gifttable-sku-wap-text-1">
                              {commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosrecibidos.warehouse.label")}:{" "}
                              {product?.guestInfo?.popupStore
                                ? product.guestInfo.popupStore
                                : product?.purchaseInfo?.warehouseInfo || ""}
                            </span>
                          </div>
                          {!isPersonal && 
                          <div className="giftlist-gifttable-sku-box-wap">
                            <span className="giftlist-gifttable-sku-wap giftlist-gifttable-sku-wap-text-1">
                              {commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.delivery.address.invited.label")}:{" "}
                              {product.guestInfo.name
                                ? product.guestInfo.name
                                : commonUtil.getLabel(
                                    this.props.lables.EventAdminPage,
                                    "adminpage.regalosrecibidos.guest.name"
                                  ) || ""}
                            </span>
                          </div>}
                          {isBonusContainerVisible &&
                          <div className="giftlist-gifttable-sku-box-wap">
                            <span className="giftlist-gifttable-sku-wap giftlist-gifttable-sku-wap-text-1">
                              {commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.bonus.label")}:{" "}
                            </span>
                            {product.bonusInfo === "true" ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                              >
                                <path
                                  d="M4.39961 8.4499L2.29961 6.3499L1.59961 7.0499L4.39961 9.8499L10.3996 3.8499L9.69961 3.1499L4.39961 8.4499Z"
                                  fill="#333333"
                                />
                              </svg>
                            ) : (
                              <div className="bono-text">
                                <span>X</span>
                              </div>
                            )}
                          </div>}
                        </div>
                        <div className="giftlist-gifttable-date-box-wap">
                          <span className="giftlist-gifttable-date-text-wap">
                          {commonUtil.getLabel(
                            this.props.lables.eventAccountStatement,
                            'accountStatement.gift.table.purchase.date.text',
                          )}:{" "}
                            {product?.guestInfo?.dateofPurchase
                              ? product.guestInfo.dateofPurchase
                              : product?.purchaseInfo?.dateofPurchase || ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )
              )
            ) : (
              <NoGiftItemsMessageWap lables={this.props.lables} quantity={purchasedItemSummaryInfoData?.itemSummary?.totalPurchasedItemsCount}/>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default GiftSummaryTableWap;
